module.exports = __webpack_public_path__ + "assets/3f97e9c71b8fb87e68ac4440696abb9e.png";